export enum TodosMutations {
  ADD_NEW_TODO = "addNewTodo",
  REMOVE_TODO_BY_ID = "removeTodoById",
  TOGGLE_DONE = "toggleDone",
  SET_NEW_TODOS = "setNewTodos",
}
